import React from 'react';
import FileImport from '../component/FileImport';
import FileImportHistory from '../component/FileImportHistory';

const ObjectImport = () => (
  <React.Fragment>
    <FileImport />
    <FileImportHistory />
  </React.Fragment>
);

export default ObjectImport;



// WEBPACK FOOTER //
// ./src/views/Setup/ObjectImport/container/index.jsx